import { reducer } from './store'
export * from './views'
export * from './selectors'

export const storeToInstall = {
  navigation: reducer
}
